import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();

  const handleNavClick = (sectionId) => {
    navigate(`/#${sectionId}`);
  };

  return (
    <nav className="navbar navbar-expand-md navbar-light fixed-top">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">Chendur Vishakan Bio Energy (P) Ltd</Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
          aria-controls="mainNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="mainNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
            <li className="nav-item"><button className="nav-link btn" onClick={() => handleNavClick('about')}>About</button></li>
            <li className="nav-item"><Link className="nav-link" to="/services">Services</Link></li>
            <li className="nav-item"><button className="nav-link btn" onClick={() => handleNavClick('products')}>Products</button></li>
            <li className="nav-item"><Link className="nav-link" to="/technology-innovation">Technology & Innovation</Link></li>
            <li className="nav-item"><Link to="/#contact" className="btn btn-dark ms-md-2">Contact</Link></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
